import styles from './customer-details.module.scss';
import { Col, Row } from 'reactstrap';
import { GetCurrentCompany } from '../../customer-context/customer-context';
import { useGetRequestNewHook } from '../../requestUtils';
import { Box, Container } from '@frontend-workspace/react-shared-lib';
import CustomerDetailsGrid from '../customer-details-grid/customer-details-grid';
import BasicCustomerDetails from '../basic-customer-details/basic-customer-details';
import PageTitle from '../../page-title/page-title';
import { ICompanyUserAccounts } from '../../_models/company-user-accounts';
import { ICustomerGroupCompanies } from '../../_models/customer-group-companies';
import BasicCustomerDetailsSkeleton from '../basic-customer-details/basic-customer-details-skeleton';
import CustomerDetailsGridSkeleton from '../customer-details-grid/customer-details-grid-skeleton';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CustomerDetailsProps { }

export function CustomerDetails(props: CustomerDetailsProps) {
  const { t } = useTranslation();
  const currentCompany = GetCurrentCompany();
  const companyNumber = currentCompany ? currentCompany.number : "";
  const { data: company, getData: getCompany }: { data: any, getData: () => void } = useGetRequestNewHook(`companies/${companyNumber}`, undefined, [currentCompany]);
  const { data: companyUserAccounts, getData: getUserAccounts }: { data: ICompanyUserAccounts[], getData: () => void } = useGetRequestNewHook(`companies/${companyNumber}/userAccounts`, [], [currentCompany]);
  const { data: customerGroupCompanies, getData: getGroupCompanies }: { data: ICustomerGroupCompanies[], getData: () => void } = useGetRequestNewHook(`companies/${companyNumber}/groupCompanies`, undefined, [currentCompany]);

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t('app.customerDetails')} showNoCompanyMessage={!currentCompany} />
            {!company ?
              <BasicCustomerDetailsSkeleton /> :
              <BasicCustomerDetails
                company={company}
                userAccounts={companyUserAccounts.filter(ua => !ua.isDeleted)}
                getCompany={getCompany}
              />}
            {!currentCompany ?
              <CustomerDetailsGridSkeleton /> :
              <CustomerDetailsGrid
                companyUserAccounts={companyUserAccounts}
                customerGroupCompanies={customerGroupCompanies}
                companyNumber={companyNumber}
                getUserAccounts={getUserAccounts}
              />
            }
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default CustomerDetails;